import { Breadcrumb, Tabs, Typography } from "antd";
import { Outlet, useLoaderData, useNavigate } from "react-router-dom";
import { OrgMemberDetailsPageLoaderType } from "./loaders";
import { useTranslation } from "react-i18next";
import {
  breadcrumbHomeItem,
  breadcrumbItem,
  breadcrumbLinkItem,
} from "~/components";
import { MemberDetailsTab } from "./components";

export const OrgMemberDetailsPage = () => {
  const { t } = useTranslation();
  const loaderData = useLoaderData() as OrgMemberDetailsPageLoaderType;
  const navigate = useNavigate();

  const memberName =
    `${loaderData.memberDetails.firstName || ""} ${
      loaderData.memberDetails.lastName || ""
    }`.trim() ||
    loaderData.memberDetails.username ||
    "Member";

  return (
    <>
      <Breadcrumb
        separator=">"
        items={[
          breadcrumbHomeItem,
          breadcrumbLinkItem(
            `/organization/${loaderData.organizationDetails.id}`,
            `${t("Organization")}: ${loaderData.organizationDetails.name}`
          ),
          breadcrumbItem(`${t("Member_Details")}: ${memberName}`),
        ]}
      />

      <Typography.Title level={1} data-tour="org-member-header">
        {memberName}
        <Typography.Text
          type="secondary"
          style={{ fontSize: "0.6em", marginLeft: "1rem" }}
        >
          {loaderData.memberDetails.email}
        </Typography.Text>
      </Typography.Title>

      <Tabs
        data-tour="org-member-tabs"
        onChange={(key) => {
          const basePath = `/organization/${loaderData.organizationDetails.id}/member/${loaderData.memberDetails.id}`;
          switch (key) {
            case "details": {
              navigate(`${basePath}?tab=details`);
              break;
            }
            case "lifecycle-access": {
              navigate(`${basePath}/lifecycle-access?tab=lifecycle-access`);
              break;
            }
            case "instance-access": {
              navigate(`${basePath}/instance-access?tab=instance-access`);
              break;
            }
          }
        }}
        defaultActiveKey="details"
        items={[
          {
            key: "details",
            label: <Typography.Text>{t("Details")}</Typography.Text>,
            children: (
              <MemberDetailsTab
                memberDetails={loaderData.memberDetails}
                canUpdateMemberRights={loaderData.canUpdateMemberRights}
                isSuperAdmin={loaderData.isSuperAdmin}
              />
            ),
          },
          {
            key: "lifecycle-access",
            label: <Typography.Text>{t("Lifecycle_Access")}</Typography.Text>,
            children: (
              <div data-tour="org-member-access-content">
                <Outlet />
              </div>
            ),
          },
          {
            key: "instance-access",
            label: <Typography.Text>{t("Instance_Access")}</Typography.Text>,
            children: (
              <div data-tour="org-member-access-content">
                <Outlet />
              </div>
            ),
          },
        ]}
      />
    </>
  );
};
